module.exports = __webpack_public_path__ + "static/media/arrow-from-top.013fe321.svg";